import React, { forwardRef, useEffect, useState } from 'react';
import windowScrollTop from 'syf-js-utilities/helpers/windowScrollTop';
import { FA_ARROW_UP } from '../../../const/iconProps';
import { ArrowUpIcon, CircleButton } from './subcomponents';
const defaultIsButtonVisible = () => window.scrollY >= window.innerHeight * 0.5;
const BackToTop = forwardRef(({ className, ariaLabel = 'Back to Top', isButtonVisible = defaultIsButtonVisible }, ref) => {
    const [showButton, setShowButton] = useState(false);
    // Creating an event listener to check for the vertical scroll position
    useEffect(() => {
        const toggleButtonVisibility = () => {
            setShowButton(isButtonVisible());
        };
        window.addEventListener('scroll', toggleButtonVisibility);
        window.addEventListener('resize', toggleButtonVisibility);
        return () => {
            window.removeEventListener('scroll', toggleButtonVisibility);
            window.removeEventListener('resize', toggleButtonVisibility);
        };
    }, [isButtonVisible]);
    const onClick = () => {
        // Finding the first element on the page
        const focusableElement = document.querySelector('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        // Scrolling to the top of the page
        windowScrollTop();
        // Focusing on the first element on the page
        focusableElement.focus({
            preventScroll: true
        });
    };
    return (showButton && (React.createElement(CircleButton, { className: className, onClick: onClick, "aria-label": ariaLabel, ref: ref },
        React.createElement(ArrowUpIcon, { icon: FA_ARROW_UP, "aria-hidden": true }))));
});
export default BackToTop;
